import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Index from "./pages/Index";
import Contact from "./pages/Contact";
import Insights from "./pages/Insights";
import InsightPost from "./pages/InsightPost";
import GrowthSystem from "./pages/GrowthSystem";
import RevenueSystem from "./pages/RevenueSystem";
import WhatWeBuild from "./pages/WhatWeBuild";
import Fractional from "./pages/Fractional";
import HowWeWork from "./pages/HowWeWork";
import Impact from "./pages/Impact";
import Team from "./pages/Team";
import FAQ from "./pages/FAQ";
import SystemsWhisperer from "./pages/SystemsWhisperer";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <LanguageProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/insights/:slug" element={<InsightPost />} />
            <Route path="/growth-system" element={<GrowthSystem />} />
            <Route path="/revenue-system" element={<RevenueSystem />} />
            <Route path="/what-we-build" element={<WhatWeBuild />} />
            <Route path="/fractional" element={<Fractional />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/team" element={<Team />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/systems-whisperer" element={<SystemsWhisperer />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </LanguageProvider>
);

export default App;
